import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

interface DatePickProps {
  onChange: (date: Date | null) => void;
}

const DatePick: React.FC<DatePickProps> = ({ onChange }) => {
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());

  const handleDateChange = (date: Date | null) => {
    if (date instanceof Date) {
      setSelectedDate(date);
    }
    onChange(date);
  };

  return (
    <div className="date-picker-container">
      <DatePicker
        selected={selectedDate}
        onChange={handleDateChange}
        dateFormat="yyyy/MM/dd"
        className="date-picker-input"
      />
    </div>
  );
};

export default DatePick;
